
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'PageLoading',
  setup: () => {
    return {};
  }
});
